import React, { useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import boy from "../img/school.png";
import main from "../img/main.png";
import JumpImg from "../img/jump_children.png";
import { Play } from "lucide-react";
import Review from "../components/Review";
import Package from "../components/Package";
import Protect from "../components/Protect";
import arrow from "../img/arrow.png";
import videoThumbnail from "../img/student.png";
import Modal from "../components/Modal";

const reviews = [
  {
    text: "As a daycare owner, I need to ensure my staff is trained. AngelWatch not only meets state requirements but goes beyond to ensure real-world readiness.",
    name: "Sarah O’Connor",
    work: "Daycare Owner",
  },
  {
    text: "In all my years of teaching, I’ve never taken a course this thorough and effective. It truly stands out above the rest.",
    name: "James Monroe",
    work: "Elementary School Teacher",
  },
  {
    text: "This training was eye-opening. I learned more in a few hours than I did in years of traditional emergency training.",
    name: "Lisa Mendoza",
    work: "Daycare Owner, Director",
  },
];

export default function GetCertified() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Header />
      <div className="font-sans">
        <div className="relative text-white">
          {/* Hero Image */}
          <div className="lg:h-[354px] h-[150px] w-full overflow-hidden">
            <img
              src={main}
              alt="How it works"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 flex items-center justify-start">
            <div className="max-w-7xl w-full mx-auto px-4">
              <div className="flex flex-col">
                <h1
                  style={{ fontFamily: "Fredoka" }}
                  className="lg:text-[61px] text-[24px] font-bold mb-2 text-white"
                >
                  Get Certified
                </h1>
                <div
                  style={{ fontFamily: "Poppins" }}
                  className="text-white"
                >
                             Home &gt; <span className="text-white">Get Certified</span>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <div>
            {/* Top Section */}

            {/* Info Section */}
            <div className="bg-white  lg:py-12 space-y-10">
              {/* Top Section with Image and Text */}
              <div className="flex mt-4  max-w-7xl mx-auto flex-col md:flex-row justify-between items-center gap-10">
                {/* Text */}
                <div className="md:w-1/2 lg:space-y-4">
                  <h2
                    style={{ fontFamily: "Fredoka" }}
                    className="lg:text-[34px] p-1 text-[24px] text-black font-semibold"
                  >
                    Get Your School Or Center Certified For Emergency
                    Preparedness Today
                  </h2>
                  <p
                    style={{ fontFamily: "Poppins" }}
                    className="text-sm p-2 text-gray-700 p-1 lg:text-[20px] text-[15px] leading-relaxed"
                  >
                    Emergency readiness has never been optional. Schools and
                    child care centers nationwide—large and small—are unprepared
                    for emergencies like lockdowns, fires, and medical
                    emergencies. AngelWatch Certification empowers your entire
                    organization with strategies that reduce liability, stress,
                    fines, and full preparedness—and gives you peace of
                    mind—starting today.
                  </p>
                </div>

                {/* Video/Image Block */}
                <div className="relative md:w-1/2 w-full">
                  {/* <img
                    src={boy}
                    alt="School Emergency Certification"
                    className="w-full rounded shadow-md"
                  /> */}
                <img
                  src={videoThumbnail}
                  alt="Emergency video preview"
                  className="w-full max-h-[550px] object-cover rounded-tl-[50px] rounded-br-[50px] md:rounded-tl-[100px] md:rounded-br-[100px] shadow-lg w-full cursor-pointer"
                  onClick={() => setIsOpen(true)}
                />
            {/* <iframe className=" w-full h-[350px]" src="https://www.youtube.com/embed/qqgfMU7nmFc?si=vZS1I4U8YeJo2QSm" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}

                  {/* <div className="absolute inset-0 flex items-center justify-center">
                    <div className="bg-yellow-400 rounded-full p-3">
                      <Play className="w-6 h-6 text-white" />
                    </div>
                  </div> */}
                </div>
              </div>

              {/* Certification Package Section */}
              <div className="p-6 bg-[#FCF7EE] pt-10 rounded shadow text-sm space-y-4">
                <div className="max-w-7xl mx-auto">
                  <h3
                    style={{ fontFamily: "Fredoka" }}
                    className="font-semibold text-base lg:text-[34px] text-[20px]"
                  >
                    What’s Included in Your Certification Package
                  </h3>

                  <div className="space-y-4 pt-4 pb-10">
                    {[
                      "Full Online Emergency Preparedness Training",
                      "Active Shooter, Lockdown, Fire, and Medical Emergency Protocols",
                      "Emergency Plan Templates to Meet State Licensing Requirements",
                      "Staff Tracking Compliance Dashboard",
                      "Official AngelWatch Certificates for All Staff",
                    ].map((item, index) => (
                      <div key={index} className="flex items-start gap-3">
                        <img
                          src={arrow}
                          className="w-[14px] mt-[6px]"
                          alt="arrow"
                        />
                        <p
                          style={{ fontFamily: "Poppins" }}
                          className="lg:text-[20px] text-[15px] text-black"
                        >
                          {item}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="max-w-7xl mx-auto pb-10">
              <div className="max-w-6xl  bg-[#F0AA00] mx-auto rounded-md p-4 mt-10">
                <h2
                  style={{ fontFamily: "Fredoka" }}
                  className="lg:text-[30px] text-[20px] font-medium text-center text-white "
                >
                  Every day without certification leaves your students, staff,
                  and organization exposed to lawsuits, fines, and irreversible
                  tragedies. Protect your community — and your reputation — with
                  AngelWatch today.
                </h2>
              </div>
              <h2
                style={{ fontFamily: "Fredoka" }}
                className="lg:text-[40px] text-[28px] p-2 mt-10  pb-2 font-bold text-center lg:mb-12"
              >
                Pricing and Enrollment Options
              </h2>
              <div
                style={{ fontFamily: "Poppins" }}
                className="text-[18px] text-center p-2 mb-10"
              >
                Best for licensed schools, preschools, and daycare centers.
                Gives directors full access to training, compliance
                documentation, recertification management, and emergency
                protocol rewriting for every staff member.
              </div>
              <div
                style={{ fontFamily: "Poppins" }}
                className="text-[18px] pb-10 text-center"
              >
                Ideal for teachers, aides, substitutes, and independent
                providers. Offers complete access to our training and
                certification platform on a personal level period.
              </div>
              <Protect img={JumpImg} />
            </div>

            <Package />

            {/* Testimonials & Email */}

            {/* Footer Bar */}
          </div>
        </div>
      </div>
      <Review reviews={reviews} />
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <iframe className=" w-full h-[400px]" src="https://www.youtube.com/embed/qqgfMU7nmFc?si=vZS1I4U8YeJo2QSm" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </Modal>
      <Footer />
    </>
  );
}
